import React, { FC, useState, useRef, useEffect } from "react";
// libs
import NextImage from "next/image";
import { DateTime } from "luxon";
// components
import DatePicker from "src/components/ui/calendar/DatePicker";
// theme
import {
  Content,
  DateContainer,
  CalendarContainer,
  CalendarText,
  ArrowDown,
  Container,
} from "./ChooseDate.styles";

interface IChooseDateProps {
  initDate?: string;
  onChangeCb?: (date: string) => void;
}

const ChooseDate: FC<IChooseDateProps> = ({ initDate, onChangeCb }) => {
  const dropdownOpenDate: any = useRef();
  const dropdownCalendar: any = useRef();
  const [openDate, setOpenDate] = useState<boolean>(false);
  const [choosedDate, setChoosedDate] = useState(() => {
    if (initDate) {
      return DateTime.fromFormat(initDate, "dd/LL/yyyy").toJSDate();
    }
    return new Date();
  });
  const calendarValue = DateTime.fromJSDate(choosedDate).toFormat("d LLLL");

  const handleOpenCalendar = () => {
    setOpenDate(!openDate);
  };

  const handleChoosedDate = (date: Date) => {
    onChangeCb?.(DateTime.fromJSDate(date).toFormat("dd/LL/yyyy"));
    setChoosedDate(date);
  };

  const closeDropdownDate = (e: MouseEvent) => {
    setOpenDate(false);
    if (e) {
      e.stopPropagation();
    }
  };

  const handleClickDateOutside = (event: MouseEvent): void => {
    if (
      !dropdownOpenDate.current.contains(event.target) &&
      !dropdownCalendar.current.contains(event.target)
    ) {
      closeDropdownDate(event);
    }
  };

  useEffect(() => {
    if (openDate) {
      document.addEventListener("mousedown", handleClickDateOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickDateOutside);
    };
  }, [openDate]);

  return (
    <Content>
      <DateContainer onClick={handleOpenCalendar} ref={dropdownOpenDate}>
        <CalendarContainer>
          <NextImage width={40} height={40} src="/icons/calendar.svg" />
        </CalendarContainer>
        <CalendarText>{calendarValue}</CalendarText>
        <ArrowDown>
          <NextImage width={12} height={7} src="/images/Home/arrow-down-grey.svg" />
        </ArrowDown>
      </DateContainer>
      {openDate && (
        <Container ref={dropdownCalendar}>
          <DatePicker choosedDate={handleChoosedDate} handleOpenCalendar={handleOpenCalendar} />
        </Container>
      )}
    </Content>
  );
};

export default ChooseDate;
